import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDJePVvBZnxiO0g7BjLkLkhfNYHl1P0nT0",
  authDomain: "naturobook-74f84.firebaseapp.com",
  projectId: "naturobook-74f84",
  storageBucket: "naturobook-74f84.firebasestorage.app",
  messagingSenderId: "742861571247",
  appId: "1:742861571247:web:e6f491e301d4a6a196005a",
  measurementId: "G-2TMS7H7GNL"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyAYaKsePwzUgK-1IMJeaHJubg_GAAThRVs",
//   authDomain: "prise-de-rdv-611d6.firebaseapp.com",
//   projectId: "prise-de-rdv-611d6",
//   storageBucket: "prise-de-rdv-611d6.firebasestorage.app",
//   messagingSenderId: "928308689861",
//   appId: "1:928308689861:web:a3844bd6f13d3ce26fe9ac",
//   measurementId: "G-CKNDSJWYTG"
// };

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const functions = firebase.functions();
export const storage = firebase.storage();
export default firebase;